<!--
 * @Author: your name
 * @Date: 2021-07-05 14:50:47
 * @LastEditTime: 2021-09-26 16:24:25
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\pages\brandMall\contentTemplate.vue
-->
<template>
  <div class="container">
    <div>
      <el-tabs
        v-model="activeTabName"
        class="tabs-area"
        type="card"
        @tab-click="handleClick"
      >
        <el-tab-pane
          :disabled="tabDisabled"
          label="已开通"
          name="first"
        ></el-tab-pane>
        <el-tab-pane
          :disabled="tabDisabled"
          label="装修中"
          name="second"
        ></el-tab-pane>
      </el-tabs>
      <div class="content_wrapper">
        <div v-if="activeTabName == 'second'" class="steps">
          <el-steps :active="activeStep" align-center>
            <el-step
              title="草稿"
              :description="updateTime ? updateTime : ''"
            ></el-step>
            <el-step title="待审核" description=""></el-step>
            <el-step
              v-if="templateStatus != 4"
              title="审核通过"
              :description="auditTime ? auditTime : ''"
            ></el-step>
            <el-step
              v-if="templateStatus == 4"
              title="审核拒绝"
              description=""
            ></el-step>
            <el-step
              v-if="templateStatus != 4"
              title="发布"
              :description="publishTime ? publishTime : ''"
            ></el-step>
          </el-steps>
          <div style="margin-top: 10px">
            <!-- templateStatus 1:保存 2提交（待审核）3：审核通过 4：审核拒绝 5：发布  6: '变更保存中'   7:变更审核中-->
            <el-button
              v-if="templateStatus != 2 && templateStatus != 3"
              class="width80"
              @click="submitData(1)"
              >保 存</el-button
            >
            <el-button
              v-if="templateStatus == 2"
              class="width80"
              @click="callbackAuditApply()"
              >撤 回</el-button
            >
            <el-button
              v-if="
                templateStatus != 2 &&
                templateStatus != 3 &&
                templateStatus != 5
              "
              class="width80"
              :disabled="!templateId"
              @click="submitData(2)"
              >提交审核</el-button
            >
            <el-button
              v-if="templateStatus != 2 && templateStatus != 3"
              class="width80"
              :disabled="!templateId"
              @click="submitDelate()"
              >删除</el-button
            >
            <el-button
              v-if="templateStatus == 3"
              class="width80"
              :disabled="!templateId"
              @click="submitPublish()"
              >发布</el-button
            >
            <div style="float: right">
              <el-popover placement="right" width="400" trigger="hover">
                <div>
                  <p>当前的预览页面为贵公司品牌销售商城的首页。</p>
                  <p>
                    1.“全部分类”展示的是贵公司的导购类目，完成配置后，采购商可在销售商城中快速检索您的商品。
                  </p>
                  <p>
                    2.“商城首页”、“全部商品”这一区域为自定义导航，前三个导航为固定导航，无法修改，另可单独创建5个自定义导航。
                  </p>
                  <p>
                    3.“轮播图片”将是贵公司展示品牌特性、企业形象、最新活动等信息的最显著区域，最多可上传九张图片并配置对应的跳转链接。
                  </p>
                  <p>
                    4.频道图贵公司可以根据自身产品特性、类型等信息进行设置，必须设置满六张图，并配置对应的跳转链接。
                  </p>
                  <p>
                    5.广告图为贵公司的信息推广区域，可以自定义配置，仅能上传一张。
                  </p>
                  <p>
                    7.联系我们可填入贵公司联系人与联系方式，便于采购企业与贵公司进行沟通。
                  </p>
                  <el-button type="text" @click="showVideo"
                    >[查看商城装修演示视频]</el-button
                  >
                </div>

                <el-button slot="reference" type="text" size="medium"
                  >装修指南</el-button
                >
              </el-popover>
            </div>
          </div>
        </div>
        <div class="content_left">
          <div class="classification flex">
            <div class="unit_wrapper" @mousemove="handleOver('allCategories')">
              <allCategoriesUnit
                :active-name="activeComponents"
                :all-categories-list="controlData.allCategoriesList"
              ></allCategoriesUnit>
              <transition name="el-fade-in">
                <div
                  v-if="activeMantle == 'allCategories'"
                  class="mantle-box"
                  @mouseleave="handleOver('')"
                >
                  <div class="mantle-box-content">
                    <p>全部分类编辑</p>
                    <el-button
                      class="width200"
                      type="primary"
                      @click="choosenComments('allCategories')"
                      >编辑</el-button
                    >
                  </div>
                </div>
              </transition>
            </div>
            <div
              class="unit_wrapper"
              :class="{
                isactiveComponents: activeComponents == 'customCategories',
              }"
              @mousemove="handleOver('customCategories')"
            >
              <customCategoriesUnit
                :custom-categories-list="controlData.customCategoriesList"
              ></customCategoriesUnit>
              <transition name="el-fade-in">
                <div
                  v-if="activeMantle == 'customCategories'"
                  class="mantle-box"
                  @mouseleave="handleOver('')"
                >
                  <div class="mantle-box-content">
                    <p>自定义导航编辑</p>
                    <el-button
                      class="width200"
                      type="primary"
                      @click="choosenComments('customCategories')"
                      >编辑</el-button
                    >
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div
            class="unit_wrapper margin-b40"
            @mousemove="handleOver('banner')"
          >
            <bannerUnit
              :active-name="activeComponents"
              :banner-list="controlData.bannerList"
            ></bannerUnit>
            <transition name="el-fade-in">
              <div
                v-if="activeMantle == 'banner'"
                class="mantle-box-c"
                @mouseleave="handleOver('')"
              >
                <div class="mantle-box-content-c">
                  <p>banner图编辑</p>
                  <el-button
                    class="width200"
                    type="primary"
                    @click="choosenComments('banner')"
                    >编辑</el-button
                  >
                </div>
              </div>
            </transition>
          </div>
          <div
            class="unit_wrapper margin-b40"
            :class="{ isactiveComponents: activeComponents == 'channel' }"
            @mousemove="handleOver('channel')"
          >
            <channelUnit
              ref="channel"
              :active-name="activeComponents"
              :channel-data="controlData.channelData"
            ></channelUnit>
            <transition name="el-fade-in">
              <div
                v-if="
                  activeMantle == 'channel' && !controlData.channelData.isHidden
                "
                class="mantle-box-c"
                @mouseleave="handleOver('')"
              >
                <div class="mantle-box-content-c">
                  <p>频道图编辑</p>
                  <div class="margin-b10">
                    <el-button
                      class="width200"
                      type="primary"
                      @click="choosenComments('channel')"
                      >编辑</el-button
                    >
                  </div>
                  <div>
                    <el-button
                      class="width200"
                      type="danger"
                      @click="hiddenFloor('channel')"
                      >隐藏</el-button
                    >
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div
            class="unit_wrapper margin-b40"
            @mousemove="handleOver('advertisement')"
          >
            <advertisementUnit
              ref="advertisement"
              :active-name="activeComponents"
              :advertisement-data="controlData.advertisementData"
            ></advertisementUnit>
            <transition name="el-fade-in">
              <div
                v-if="
                  activeMantle == 'advertisement' &&
                  !controlData.advertisementData.isHidden
                "
                class="mantle-box-c"
                @mouseleave="handleOver('')"
              >
                <div class="mantle-box-content-c">
                  <p>广告图编辑</p>
                  <div class="margin-b10">
                    <el-button
                      class="width200"
                      type="primary"
                      @click="choosenComments('advertisement')"
                      >编辑</el-button
                    >
                  </div>
                  <div>
                    <el-button
                      class="width200"
                      type="danger"
                      @click="hiddenFloor('advertisement')"
                      >隐藏</el-button
                    >
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div
            class="unit_wrapper margin-b40"
            @mousemove="handleOver('floor1')"
          >
            <floor1Unit
              ref="floor1"
              :active-name="activeComponents"
              :floor-data="controlData.floorData"
            ></floor1Unit>
            <transition name="el-fade-in">
              <div
                v-if="
                  activeMantle == 'floor1' && !controlData.floorData.isHidden
                "
                class="mantle-box-c"
                @mouseleave="handleOver('')"
              >
                <div class="mantle-box-content-c">
                  <p>主推商品区编辑</p>
                  <div class="margin-b10">
                    <el-button
                      class="width200"
                      type="primary"
                      @click="choosenComments('floor1')"
                      >编辑</el-button
                    >
                  </div>
                  <div>
                    <el-button
                      class="width200"
                      type="danger"
                      @click="hiddenFloor('floor1')"
                      >隐藏</el-button
                    >
                  </div>
                </div>
              </div>
            </transition>
          </div>
          <div class="unit_wrapper margin-b40">
            <floor2Unit
              :active-name="activeComponents"
              :floor-list="controlData.floorList"
              :template-status="templateStatus"
              :active-tab-name="activeTabName"
            ></floor2Unit>
          </div>
          <div
            class="unit_wrapper"
            :class="{ isactiveComponents: activeComponents == 'contactUs' }"
            @mousemove="handleOver('contactUs')"
          >
            <contactUsUnit
              key="contactUs"
              ref="contactUs"
              :active-name="activeComponents"
              :contact-us-info="controlData.contactUsInfo"
            ></contactUsUnit>
            <transition name="el-fade-in">
              <div
                v-if="
                  activeMantle == 'contactUs' &&
                  !controlData.contactUsInfo.isHidden
                "
                class="mantle-box-c"
                @mouseleave="handleOver('')"
              >
                <div class="mantle-box-content-c">
                  <p>联系我们编辑</p>
                  <div class="margin-b10">
                    <el-button
                      class="width200"
                      type="primary"
                      @click="choosenComments('contactUs')"
                      >编辑</el-button
                    >
                  </div>
                  <div>
                    <el-button
                      class="width200"
                      type="danger"
                      @click="hiddenFloor('contactUs')"
                      >隐藏</el-button
                    >
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <div>
          <allCategoriesDialog
            :active-name="activeComponents"
            :all-categories-list="controlData.allCategoriesList"
          ></allCategoriesDialog>
          <customCategoriesDialog
            :active-name="activeComponents"
            :custom-categories-list="controlData.customCategoriesList"
          ></customCategoriesDialog>
          <bannerDialog
            :active-name="activeComponents"
            :banner-list="controlData.bannerList"
          ></bannerDialog>
          <channelDialog
            :active-name="activeComponents"
            :channel-data="controlData.channelData"
          ></channelDialog>
          <advertisementDialog
            :active-name="activeComponents"
            :advertisement-data="controlData.advertisementData"
          ></advertisementDialog>
          <floor1Dialog
            :active-name="activeComponents"
            :floor-data="controlData.floorData"
          ></floor1Dialog>
          <floor2Dialog
            :active-name="activeComponents"
            :active-floor="activeFloor"
            :floor-list="controlData.floorList"
          ></floor2Dialog>
          <contactUsDialog
            :active-name="activeComponents"
            :contact-us-info="controlData.contactUsInfo"
          ></contactUsDialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import { epecMallUrl } from '../../api/config';
import cmsApi from '../../api/cms/index.js';
import cmsOssApi from '../../api/cms-oss/index.js';
import allCategoriesUnit from '../../components/templates/allCategoriesUnit.vue';
import allCategoriesDialog from '../../components/templates/allCategoriesDialog.vue';
import customCategoriesUnit from '../../components/templates/customCategoriesUnit.vue';
import customCategoriesDialog from '../../components/templates/customCategoriesDialog.vue';
import bannerUnit from '../../components/templates/bannerUnit.vue';
import bannerDialog from '../../components/templates/bannerDialog.vue';
import channelUnit from '../../components/templates/channelUnit.vue';
import channelDialog from '../../components/templates/channelDialog.vue';
import advertisementUnit from '../../components/templates/advertisementUnit.vue';
import advertisementDialog from '../../components/templates/advertisementDialog.vue';
import floor1Unit from '../../components/templates/floor1Unit.vue';
import floor1Dialog from '../../components/templates/floor1Dialog.vue';
import floor2Unit from '../../components/templates/floor2Unit.vue';
import floor2Dialog from '../../components/templates/floor2Dialog.vue';
import contactUsUnit from '../../components/templates/contactUsUnit.vue';
import contactUsDialog from '../../components/templates/contactUsDialog.vue';

export default {
  components: {
    allCategoriesUnit,
    allCategoriesDialog,
    customCategoriesUnit,
    customCategoriesDialog,
    bannerUnit,
    bannerDialog,
    channelUnit,
    channelDialog,
    advertisementUnit,
    advertisementDialog,
    floor1Unit,
    floor1Dialog,
    floor2Unit,
    floor2Dialog,
    contactUsUnit,
    contactUsDialog,
  },
  data() {
    return {
      activeComponents: '',
      activeFloor: '',
      activeTabName: 'second',
      activeStep: 1,
      tabDisabled: true,
      controlData: {
        allCategoriesList: [],
        customCategoriesList: [
          {
            name: '商城首页',
            linkUrl: epecMallUrl,
            type: 1, //  1 默认导航 2 自定义
          },
          {
            name: '全部商品',
            linkUrl: epecMallUrl,
            type: 1, //  1 默认导航 2 自定义
          },
          {
            name: '企业资质',
            linkUrl: `${epecMallUrl}/brandMall/brandMallInfo`,
            type: 1, //  1 默认导航 2 自定义
          },
        ],
        bannerList: [],
        channelData: {
          isHidden: false,
          channelList: [],
        },
        advertisementData: {
          isHidden: false,
          advertisementList: [],
        },
        floorData: {
          isHidden: false,
          title: '',
          linkUrl: '',
          productList: [],
        },
        floorList: [
          {
            isHidden: false,
            title: '',
            linkUrl: '',
            productList: [],
          },
          {
            isHidden: false,
            title: '',
            linkUrl: '',
            productList: [],
          },
        ],
        contactUsInfo: {
          phone: '',
          contacts: '',
          isHidden: false,
          title: '联系我们编辑',
        },
      },
      templateInfo: '',
      templateStatus: '',
      templateId: '',
      errMessagelist: [],
      auditTime: '',
      updateTime: '',
      publishTime: '',
      activeMantle: '',
      dialogVisible1: false,
    };
  },
  created() {
    this.templateInfo = this.$store.state.BRANDINfO;

    // templateStatus 1:保存 2提交（待审核）3：审核通过 4：审核拒绝 5：发布  6: '变更保存中'   7:变更审核中
    // activeStep 1 草稿 2 待审核  3 审核通过  4 发布

    if (this.templateInfo.templateStatus) {
      this.templateStatus = this.templateInfo.templateStatus;

      this.templateId = this.templateInfo.templateId;

      if (this.templateStatus < 5) {
        this.getTemplateById();
        this.tabDisabled = true;
        this.activeTabName = 'second';
        // eslint-disable-next-line eqeqeq
      } else if (this.templateStatus == 5) {
        this.activeTabName = 'first';
        this.tabDisabled = false;
        //  获取模板信息
        this.getOssTemplate();
      } else {
        this.tabDisabled = false;
        this.getTemplateById();
      }
      switch (this.templateStatus) {
        case 1:
          this.activeStep = 1;
          break;
        case 2:
          this.activeStep = 2;
          break;
        case 3:
          this.activeStep = 3;
          break;
        case 4:
          this.activeStep = 3;
          break;
        case 5:
          this.activeStep = 4;
          break;
        default:
          this.activeStep = 1;
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      // window.addEventListener("scroll", this.handleScroll, true); //监听滚动事件
    });
  },
  methods: {
    init(dataArr, type) {
      dataArr.forEach((item) => {
        this.getItem(item.chunkName, item.fragmentList, type);
      });
    },
    getItem(name, list, type) {
      const newArr = [];
      list.forEach((item) => {
        const arr =
          type == 2 ? JSON.parse(item.templateData) : item.templateData;
        newArr.push(arr);
      });
      let arr0 = [];
      if (list.length > 0) {
        arr0 =
          type == 2 ? JSON.parse(list[0].templateData) : list[0].templateData;
        // arr0=list[0].templateData;
      }
      if (name === '全部分类') {
        this.controlData.allCategoriesList = arr0;
      } else if (name === '自定义导航') {
        console.log('自定义导航==>', newArr);
        this.controlData.customCategoriesList = newArr;
      } else if (name === '轮播图') {
        this.controlData.bannerList = newArr;
      } else if (name === '频道图') {
        // 为了兼容之前配置好的数据 不然传值无法传
        console.log('频道图==>', newArr);
        console.log('频道图==>arr0', arr0);
        // eslint-disable-next-line no-prototype-builtins
        this.controlData.channelData = arr0.hasOwnProperty('isHidden')
          ? arr0
          : { isHidden: false, channelList: newArr };
      } else if (name === '广告图') {
        this.controlData.advertisementData = arr0;
      } else if (name === '主推商品区') {
        this.controlData.floorData = arr0;
      } else if (name === '主推商品楼层') {
        this.controlData.floorList = newArr;
      } else if (name === '联系我们') {
        arr0.contacts = arr0.contacts ? arr0.contacts : '';
        // eslint-disable-next-line no-prototype-builtins
        this.controlData.contactUsInfo = arr0.hasOwnProperty('isHidden')
          ? arr0
          : {
              isHidden: false,
              ...arr0,
            };
      }
    },
    checkData() {
      let isOk = true;
      this.errMessagelist = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.controlData) {
        if (key == 'allCategoriesList') {
          const arr = this.controlData[key];
          if (arr.length == 0) {
            isOk = false;
            this.errMessagelist.push('全部分类');
            // this.$message({ type: "error", message: "请添加分类"});
          }
        } else if (key == 'bannerList') {
          const arr = this.controlData[key];
          if (arr.length == 0) {
            isOk = false;
            this.errMessagelist.push('轮播图管理');
            // this.$message({ type: "error", message: "请添加轮播图"});
          }
        } else if (key == 'channelData') {
          const arr = this.controlData[key].channelList;
          const { isHidden } = this.controlData[key];
          if (arr.length == 0 && !isHidden) {
            isOk = false;
            this.errMessagelist.push('频道图管理');
            // this.$message({ type: "error", message: "请完善频道区配置信息"});
          }
        } else if (key == 'advertisementData') {
          const arr = this.controlData[key].advertisementList;
          const { isHidden } = this.controlData[key];
          if (arr.length == 0 && !isHidden) {
            isOk = false;
            this.errMessagelist.push('广告图管理');
            // this.$message({ type: "error", message: "上传广告图"});
          }
        // eslint-disable-next-line eqeqeq
        } else if (key == 'floorData') {
          const arr = this.controlData[key].productList;
          const { isHidden } = this.controlData[key];
          if (arr.length < 1 && !isHidden) {
            isOk = false;
            this.errMessagelist.push('主推商品区');
            // this.$message({ type: "error", message: "请完善主推商品区信息"});
          }
        // eslint-disable-next-line eqeqeq
        } else if (key == 'floorList') {
          // eslint-disable-next-line prefer-const
          let arr = this.controlData[key];
          // eslint-disable-next-line no-loop-func
          arr.forEach((item, index) => {
            if (item.productList.length < 1 && !item.isHidden) {
              isOk = false;
              this.errMessagelist.push(`主推商品区楼层${index + 1}`);
              //  this.$message({ type: "error", message: `请完善主推商品区楼层${index+1}信息`});
            }
          });
        // eslint-disable-next-line eqeqeq
        } else if (key == 'contactUsInfo') {
          // eslint-disable-next-line prefer-const
          let { phone, contacts } = this.controlData[key];
          if (!phone || !contacts) {
            isOk = false;
            this.errMessagelist.push(`联系我们`);
            //  this.$message({ type: "error", message: `请完善联系我们电话`});
          }
        }
      }

      return isOk;
    },

    setData() {
      const newObj = {
        timing: false,
        chunkList: [],
      };
      // eslint-disable-next-line no-restricted-syntax
      for (const i in this.controlData) {
        if (i == 'allCategoriesList') {
          const itemObj = {
            chunkName: '全部分类',
            timing: false,
            fragmentList: [],
          };
          const obj = this.controlData[i];
          itemObj.fragmentList.push({
            publishTimeStart: '',
            publishTimeEnd: '',
            modifyBy: '',
            isPublish: '',
            templateData: obj,
          });
          newObj.chunkList.push(itemObj);
        } else if (i == 'customCategoriesList') {
          const itemObj = {
            chunkName: '自定义导航',
            timing: false,
            fragmentList: [],
          };
          const arr = this.controlData[i];
          arr.forEach((item) => {
            itemObj.fragmentList.push({
              publishTimeStart: '',
              publishTimeEnd: '',
              modifyBy: '',
              isPublish: '',
              templateData: {
                ...item,
              },
            });
          });
          newObj.chunkList.push(itemObj);
        } else if (i == 'bannerList') {
          const itemObj = {
            chunkName: '轮播图',
            timing: false,
            fragmentList: [],
          };
          const arr = this.controlData[i];
          arr.forEach((item) => {
            itemObj.fragmentList.push({
              publishTimeStart: '',
              publishTimeEnd: '',
              modifyBy: '',
              isPublish: '',
              templateData: {
                ...item,
              },
            });
          });
          newObj.chunkList.push(itemObj);
        } else if (i == 'channelData') {
          const itemObj = {
            chunkName: '频道图',
            timing: false,
            fragmentList: [],
          };
          //   console.log(this.controlData[i],'Ping2');
          const obj = this.controlData[i];
          itemObj.fragmentList.push({
            publishTimeStart: '',
            publishTimeEnd: '',
            modifyBy: '',
            isPublish: '',
            templateData: obj,
          });
          newObj.chunkList.push(itemObj);

          //   console.log(newObj,'ping123')

          //   arr.forEach((item) => {
          //     itemObj.fragmentList.push({
          //       publishTimeStart: '',
          //       publishTimeEnd: '',
          //       modifyBy: '',
          //       isPublish: '',
          //       templateData: {
          //         ...item,
          //       },
          //     });
          //   });
          //   newObj.chunkList.push(itemObj);
        } else if (i == 'advertisementData') {
          const itemObj = {
            chunkName: '广告图',
            timing: false,
            fragmentList: [],
          };
          console.log(this.controlData[i], 'Ping2222');
          const obj = this.controlData[i];
          itemObj.fragmentList.push({
            publishTimeStart: '',
            publishTimeEnd: '',
            modifyBy: '',
            isPublish: '',
            templateData: obj,
          });
          newObj.chunkList.push(itemObj);
        } else if (i == 'floorData') {
          const itemObj = {
            chunkName: '主推商品区',
            timing: false,
            fragmentList: [],
          };
          const obj = this.controlData[i];
          itemObj.fragmentList.push({
            publishTimeStart: '',
            publishTimeEnd: '',
            modifyBy: '',
            isPublish: '',
            templateData: obj,
          });
          newObj.chunkList.push(itemObj);
        } else if (i == 'floorList') {
          const itemObj = {
            chunkName: '主推商品楼层',
            timing: false,
            fragmentList: [],
          };
          const arr = this.controlData[i];
          arr.forEach((item) => {
            itemObj.fragmentList.push({
              publishTimeStart: '',
              publishTimeEnd: '',
              modifyBy: '',
              isPublish: '',
              templateData: {
                ...item,
              },
            });
          });
          newObj.chunkList.push(itemObj);
        } else if (i == 'contactUsInfo') {
          const itemObj = {
            chunkName: '联系我们',
            timing: false,
            fragmentList: [],
          };
          const obj = this.controlData[i];
          itemObj.fragmentList.push({
            publishTimeStart: '',
            publishTimeEnd: '',
            modifyBy: '',
            isPublish: '',
            templateData: obj,
          });
          newObj.chunkList.push(itemObj);
        }
      }
      return JSON.stringify(newObj);
    },

    handleClick(tab, event) {
      console.log(tab, event);
      if (this.activeTabName == 'second') {
        this.getTemplateById();
      } else {
        this.getOssTemplate();
      }
    },
    choosenComments(val) {
      // templateStatus 1:保存 2提交（待审核）3：审核通过 4：审核拒绝 5：发布  6: '变更保存中'   7:变更审核中
      if (
        this.templateStatus == 2 ||
        this.templateStatus == 3 ||
        this.templateStatus == 7
      ) {
        return;
      }
      if (this.templateStatus >= 5 && this.activeTabName == 'first') {
        return;
      }
      this.activeComponents = val;
    },
    choosenFloor(val) {
      this.activeFloor = val;
    },
    async submitData(type) {
      // type 1、保存   2、提交审核
      const template = this.setData();
      console.log(JSON.parse(template), 'ping123');
      // 校验数据
      if (type == 2) {
        if (!this.checkData()) {
          this.dialogFormVisible = false;
          this.$alert(
            `请完成所有内容模板的信息维护后再提交审核，当前${this.errMessagelist[0]}信息未维护`,
            '提示',
            {
              confirmButtonText: '确定',
              type: 'warning',
              callback: (action) => {
                console.log(action);
              },
            }
          );
          return;
        }
      }
      const params = {
        templateId: this.templateId,
        companyId: this.templateInfo.companyId,
        shopId: this.templateInfo.temporaryId, //
        saveFlag: type != 1, // saveFlag false 保存
        draftTemplate: template,
        columnId: 3, // 1 首页 2 普通店铺 3 旗舰店
        templateName: '',
        templateDescribe: '',
      };
        // console.log(JSON.parse(template),'ping')
        // return false

      if (type == 1) {
        if (this.templateId) {
          this.editTemplate(params); // 编辑/提交
        } else {
          delete params.templateId;
          this.addTemplate(params); // 新增
        }
      } else if (type == 2) {
        this.editTemplate(params); // 编辑/提交
      }
    },
    submitDelate() {
      this.controlData = {
        allCategoriesList: [],
        customCategoriesList: [
          {
            name: '商城首页',
            linkUrl: epecMallUrl,
            type: 1, //  1 默认导航 2 自定义
          },
          {
            name: '全部商品',
            linkUrl: epecMallUrl,
            type: 1, //  1 默认导航 2 自定义
          },
          {
            name: '企业资质',
            linkUrl: `${epecMallUrl}/brandMall/brandMallInfo`,
            type: 1, //  1 默认导航 2 自定义
          },
        ],
        bannerList: [],
        channelData: {
          isHidden: false,
          channelList: [],
        },
        advertisementData: {
          isHidden: false,
          advertisementList: [],
        },
        floorData: {
          isHidden: false,
          title: '',
          linkUrl: '',
          productList: [],
        },
        floorList: [
          {
            isHidden: false,
            title: '',
            linkUrl: '',
            productList: [],
          },
          {
            isHidden: false,
            title: '',
            linkUrl: '',
            productList: [],
          },
        ],
        contactUsInfo: {
          phone: '',
          contacts: '',
          isHidden: false,
          title: '',
        },
      };
      const template = this.setData();
      const params = {
        templateId: this.templateId,
        companyId: this.templateInfo.companyId,
        shopId: this.templateInfo.temporaryId, //
        saveFlag: false, // saveFlag false 保存
        draftTemplate: template,
        columnId: 3, // 1 首页 2 普通店铺 3 旗舰店
        templateName: '',
        templateDescribe: '',
      };
      this.editTemplate(params); // 编辑/提交
    },

    // 获取生效中模板
    async getOssTemplate() {
      const params = {
        companyId: this.templateInfo.companyId,
        columeId: '3', // 1 首页 2 店铺   3 旗舰店
        shopId: this.templateInfo.temporaryId,
      };
      const res = await cmsOssApi.getShopTemplateossUrl(params);
      if (res.data.chunkList) {
        this.init(res.data.chunkList, 2);
      }
    },
    // 根据获取模板
    async getTemplateById() {
      const params = {
        templateId: this.templateInfo.templateId,
      };
      const res = await cmsApi.queryTemplateById(params);
      if (res.code == 200) {
        const template = JSON.parse(res.data.draftTemplate);
        this.init(template.chunkList, 1);
        this.auditTime = res.data.auditTime;
        this.updateTime = res.data.updateTime;
        this.publishTime = res.data.publishTime;
      }
    },
    // 新增模板
    async addTemplate(params) {
      const res = await cmsApi.addTemplate(params);
      if (res.code == 200) {
        this.dialogFormVisible = false;
        this.$message({ type: 'success', message: '操作成功' });
        //  this.$store.commit("closeCurrentTag", {
        //     $router: this.$router,
        //     $route: this.$route
        // });
        this.$router.push('/brandMallMgt');
      }
    },
    // 编辑/提交 模板
    async editTemplate(params) {
      const res = await cmsApi.updateTemplate(params);
      if (res.code == 200) {
        this.dialogFormVisible = false;
        this.$message({ type: 'success', message: '操作成功' });
        this.$router.push('/brandMallMgt');
      }
    },
    async submitPublish() {
      const params = {
        templateId: this.templateId,
      };
      const res = await cmsApi.publishTemplate(params);
      if (res.code == 200) {
        this.dialogFormVisible = false;
        this.$message({ type: 'success', message: '操作成功' });
        this.$router.push('/brandMallMgt');
      }
    },
    // 待审核撤回
    async callbackAuditApply() {
      const params = {
        templateId: this.templateId,
        shopId: this.templateInfo.temporaryId, //
      };
      const res = await cmsApi.callbackAuditApply(params);
      if (res.code == 200) {
        this.$message({ type: 'success', message: '操作成功' });
        this.$router.push('/brandMallMgt');
      }
    },
    handleOver(val) {
      // templateStatus 1:保存 2提交（待审核）3：审核通过 4：审核拒绝 5：发布  6: '变更保存中'   7:变更审核中
      if (
        this.templateStatus == 2 ||
        this.templateStatus == 3 ||
        this.templateStatus == 7
      ) {
        return;
      }
      if (this.templateStatus >= 5 && this.activeTabName == 'first') {
        return;
      }
      this.activeMantle = val;
    },
    hiddenFloor(ref) {
      this.$refs[ref].hiddenFloor();
    },
    showVideo() {
      window.open(
        // eslint-disable-next-line max-len
        'https://wuzhuang-buket02.oss-cn-beijing.aliyuncs.com/video/%E5%95%86%E5%93%81%E5%8F%91%E5%B8%83%E5%8F%8A%E8%A3%85%E4%BF%AE/%E5%93%81%E7%89%8C%E9%94%80%E5%94%AE%E5%95%86%E5%9F%8E%E8%A3%85%E4%BF%AE%E6%93%8D%E4%BD%9C.mp4',
        '_blank'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/css/theme.scss';
.content_wrapper {
  // display: flex;
  overflow: auto;
  position: relative;
  .steps {
    width: 1200px;
    margin: 10px 0 20px 0px;
  }
  .content_left {
    width: 1200px;
    background: #fff;
    margin-left: 10px;
    .classification {
      position: relative;
    }
    .classification:after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: $main-col;
      z-index: 1;
    }
  }
  .unit_wrapper {
    position: relative;
    .mantle-box {
      position: absolute;
      z-index: 1000;
      left: -10px;
      bottom: -75px;
      right: -10px;
      top: -10px;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      flex-direction: column-reverse;
      .mantle-box-content {
        text-align: center;
        margin-bottom: 10px;
        p {
          color: #fff;
          line-height: 32px;
          font-weight: bold;
        }
      }
    }
    .mantle-box-c {
      position: absolute;
      z-index: 1000;
      left: 0;
      bottom: 0;
      right: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      flex-direction: column;
      .mantle-box-content-c {
        text-align: center;
        p {
          color: #fff;
          line-height: 32px;
          font-weight: bold;
        }
      }
    }
  }
}
.isactiveComponents {
  position: relative;
  z-index: 20;
}

.isactiveComponents:after {
  content: '';
  position: absolute;
  left: 0px;
  bottom: 0;
  top: 0;
  right: 0;
  border: 2px dashed red;
}
.footer-btn {
  // background: #fff;
  // position: relative;
  // bottom:40px;
  // left:800px;
  // width: 1200px;
  // // text-align: center;
  // background: #fff;
  // height: 60px;
  // line-height: 60px;
  // position: absolute;
  // left:30px;
  // bottom:22px;
  ::v-deep .el-button {
    box-shadow: 0 0 6px rgb(0 0 0 / 12%);
  }
}

::v-deep {
  .el-rate__icon {
    font-size: 20px;
    margin-right: 2px;
  }

  .tabs-area {
    width: 100%;
    margin-bottom: 20px;

    .el-tabs__nav {
      border-radius: 0;
    }

    .el-tabs__header {
      margin-bottom: 0;
    }

    .el-tabs__nav .el-tabs__item {
      width: 170px;
      text-align: center;
      font-size: 14px;
      line-height: 40px;
      height: 40px;

      &.is-active {
        background: #f4f7ff;
        color: #0064c8;
      }

      &.is-active::after {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        content: '';
        width: 100%;
        height: 2px;
        background: #0064c8;
      }
    }
  }
}
</style>
